<ng-container *appTranslate="let t">
  <new-ui-dashboard-card>
    <ng-template #header>
      <new-ui-dashboard-card-header
        [title]="t('dashboard.candidateStates.title')"
        [routerLink]="settings.isLicensed ? '/app/collections/edit' : null"
      >
        <new-ui-button (onClick)="filter.toggle($event)" icon="pi pi-filter" severity="secondary"></new-ui-button>
      </new-ui-dashboard-card-header>
    </ng-template>

    @defer (when data()) {
      <div class="h-fit col mobile:row mobile:flex-row gap-8">
        <p-chart height="175px" width="175px" type="doughnut" [data]="data()" [options]="options" />

        @if (!showHistory()) {
          <div class="grid w-full gap-6 grid-cols-3">
            @for (state of data().datasets[0].data; track $index) {
              <new-ui-state-item
                [label]="data().labels[$index]"
                [color]="data().datasets[0].backgroundColor[$index]"
                [stateCount]="state"
              />
            }
          </div>
        }

        @if (historyData(); as historyData) {
          @if (showHistory()) {
            <div class="grid w-full gap-6 grid-cols-3">
              @for (state of data().datasets[0].data; track $index) {
                <new-ui-state-item
                  [label]="data().labels[$index]"
                  [stateCount]="state"
                  [color]="data().datasets[0].backgroundColor[$index]"
                  [stateDiff]="state - getDiff(data().keys[$index], historyData)"
                />
              }
            </div>
            <p-chart height="127px" width="127px" type="doughnut" [data]="historyData" [options]="options" />
          }
        }
      </div>
    } @placeholder {
      <div class="h-fit col mobile:row mobile:flex-row gap-8">
        <p-skeleton shape="circle" size="175px" />
        <div class="grid w-full gap-6 grid-cols-3">
          @for (item of [1, 2, 3, 4, 5]; track item) {
            <div class="col gap-1">
              <p-skeleton class="h-6 w-12" />
              <p-skeleton class="h-4 w-16" />
            </div>
          }
        </div>
      </div>
    }
  </new-ui-dashboard-card>

  <p-popover #filter>
    <div class="col">
      <p-multiselect
        [(ngModel)]="selectedStates"
        [options]="shownStates()"
        (onChange)="dataSubject.next($event.value); updateHistoryData()"
      ></p-multiselect>
      <div class="row items-center">
        <p-toggleswitch [(ngModel)]="showHistory" (onChange)="updateHistoryData()"></p-toggleswitch>
        <p-select
          [(ngModel)]="selectedHistory"
          [options]="historyOptions"
          [disabled]="!showHistory()"
          (onChange)="updateHistoryData()"
        ></p-select>
      </div>
    </div>
  </p-popover>
</ng-container>
